import { Box } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const LinkDisplay = ({ children }: Props) => (
  <Box
    display="flex"
    alignItems="center"
    gap={2}
    p={3}
    width="100%"
    sx={({ spacing }) => ({
      backgroundColor: Colors.Gray,
      borderRadius: spacing(1.5),
      border: `2px dashed ${Colors.Border}`,
    })}
  >
    {children}
  </Box>
);
